import { Grid } from '@material-ui/core';
import React from 'react';

function CartItemInfo({ icon, title, value, noIcon = false }) {
    if (value === '' || !value) {
        return null;
    }
    return (
        <Grid container spacing={1} className="cartinfo">
            <Grid
                item
                className={!icon ? 'iconspace' : ''}
                style={noIcon ? { width: 0, paddingLeft: 0, paddingRight: 0 } : {}}
            >
                {icon}
            </Grid>
            <Grid item>
                <b>{title ? `${title}: ` : ''}</b>
                {value}
            </Grid>
        </Grid>
    );
}

export default CartItemInfo;
